import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import resolvePath from '../../misc/resolvePath';
import EventListItem from '../elements/EventListItem';
import Scrollable from '../elements/Scrollable';
import Tabs from '../elements/Tabs/old';
import TopBarEvent from '../elements/TopBar/TopBarEvent';
import LoadCommunity from '../loaders/LoadCommunity';
import HasCommunity from '../validate/HasCommunity';
import WaitWhileBusy from '../WaitWhileBusy';
import Screen from './Screen';

class CommunityAgenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabUpcoming: true,
            tabAll: false,
        };
    }
    componentDidMount() {
        if (!this.props.event.subevents?.length) {
            app.history.replace(resolvePath(app.history.location.pathname, '..'));
        }
        this.props.notifications.forEach(notif => {
            app.api.notifications.markRead(notif.id);
        });
    }
    render() {
        let {event, i18n} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event}>{i18n['label.events-agenda']}</TopBarEvent>
                    <Tabs selectedTabStyle={event._local.styles.button_secondary}>
                        {this.props.upcomingSubevents.length ? (
                            <button type="button" selected={this.state.tabUpcoming} onClick={this.handleTabSelection.bind(this, 'upcoming')}>
                                {i18n['label.upcoming']}
                            </button>
                        ) : null}
                        <button
                            type="button"
                            selected={this.state.tabAll || !this.props.upcomingSubevents.length}
                            onClick={this.handleTabSelection.bind(this, 'all')}>
                            {i18n['label.all-events']}
                        </button>
                    </Tabs>
                    <hr />
                </div>
            ),
            events;

        if (this.state.tabUpcoming && this.props.upcomingSubevents.length) {
            events = this.props.upcomingSubevents;
        } else {
            events = this.props.allSubevents;
        }

        return (
            <Screen header={header}>
                <Scrollable>
                    {events.map(event => {
                        let href = ['/events', event.id];

                        if (event.agenda_type) {
                            href = ['.', 'item', event.id];
                        } else if (!event.joined) {
                            href = ['.', 'subevent', event.id];
                        }

                        return <EventListItem key={event.id} event={event} href={href.join('/')} />;
                    })}
                </Scrollable>
            </Screen>
        );
    }
    handleTabSelection(selected) {
        this.setState({
            tabUpcoming: selected == 'upcoming',
            tabAll: selected == 'all',
        });
    }
}

const ConnectCommunityAgenda = connect((state, props) => {
    let event = state.events[props.eventId].event,
        now = moment(),
        allSubevents = _(event.subevents)
            .sortBy(event => -1 * moment(event.start).valueOf())
            .value(),
        upcomingSubevents = _(allSubevents)
            .filter(event => moment().isBefore(event.end))
            .sortBy(event => moment(event.start).valueOf())
            .value();
    return {
        event,
        allSubevents,
        upcomingSubevents,
        i18n: state.i18n.translations,
        notifications: _(state.events[props.eventId].notifications.eventMessage)
            .filter(notif => _.get(notif, 'content.data.target', '').split('/')[0] == 'events')
            .reject(notif => notif.read)
            .value(),
    };
})(CommunityAgenda);

export default props => (
    <LoadCommunity eventId={props.match.params.eventId}>
        <WaitWhileBusy>
            <HasCommunity eventId={props.match.params.eventId}>
                <ConnectCommunityAgenda {...props.match.params} />
            </HasCommunity>
        </WaitWhileBusy>
    </LoadCommunity>
);
